export default {
  online_shop: 'Magazin online',
  storefront: 'Vitrină',
  reservations: 'Rezervări',
  import: 'Import',
};
